import { DetailsHeader, DetailsList, DetailsRow } from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SORTING_KEYS } from '../../../../constants/sortingKeys';
import { filterAndSortingKeys } from '../../../../utilities/filterAndSortingsUtil';
import { getColumnHeader } from './GetFieldTemplateHeader';

export const FieldTemplateVisualList = ({
  items,
  onFieldTemplateClick,
  filterAndSortingSelection,
  setFilterAndSortingSelection,
  listSelection,
  fieldTypeEnum,
}) => {
  const { t: translator } = useTranslation();

  const onFieldTemplateClickCallback = (item) => {
    onFieldTemplateClick && onFieldTemplateClick(item.key);
  };

  const columnHeader = getColumnHeader(translator, fieldTypeEnum);

  const selectionKey =
    items && items.length
      ? items
          .map((i) => i.key)
          .sort()
          .join('')
      : 'none';

  const sortingKey = filterAndSortingSelection[filterAndSortingKeys.sortingKey];

  return (
    <div className="fieldTemplate-lists">
      {
        <DetailsList
          items={items}
          setKey={selectionKey}
          selection={listSelection}
          isCompactMode={false}
          columns={columns(sortingKey, columnHeader)}
          ariaLabel={translator('ariaLabel.fieldTemplateListLabel')}
          ariaLabelForSelectAllCheckbox={translator('ariaLabel.listSelectAll')}
          ariaLabelForSelectionColumn={translator(
            'ariaLabel.listSelectionColumn',
          )}
          onColumnHeaderClick={onColumnHeaderClick(
            sortingKey,
            filterAndSortingSelection,
            setFilterAndSortingSelection,
          )}
          onRenderDetailsHeader={(props) => {
            return (
              <DetailsHeader
                {...props}
                styles={listStyle}
                ariaLabel={translator('ariaLabel.listHeader')}
              />
            );
          }}
          onRenderRow={(props) => {
            return <DetailsRow tabIndex="0" {...props} styles={listStyle} />;
          }}
          compact={false}
          onItemInvoked={onFieldTemplateClickCallback}
        />
      }
    </div>
  );
};

const columns = (sortingKey, columnHeader) => [
  {
    key: 'title',
    name: columnHeader,
    ariaLabel: columnHeader,
    fieldName: 'title',
    data: 'string',
    isPadded: true,
    isResizable: false,
    minWidth: 500,
    isSorted:
      sortingKey === SORTING_KEYS.TITLEALPHABETICAL ||
      sortingKey === SORTING_KEYS.TITLEALPHABETICAL_REVERSE,
    isSortedDescending: sortingKey === SORTING_KEYS.TITLEALPHABETICAL,
  },
];

const onColumnHeaderClick = (
  sortingKey,
  filterAndSortingSelection,
  setFilterAndSortingSelection,
) => (_, col) => {
  let resultingSortingKey = null;

  if (col.key === 'title') {
    if (sortingKey === SORTING_KEYS.TITLEALPHABETICAL) {
      resultingSortingKey = SORTING_KEYS.TITLEALPHABETICAL_REVERSE;
    } else {
      resultingSortingKey = SORTING_KEYS.TITLEALPHABETICAL;
    }
  }
  if (resultingSortingKey) {
    let currFilterAndSortingSelection = Object.assign(
      {},
      filterAndSortingSelection,
    );
    currFilterAndSortingSelection[
      filterAndSortingKeys.sortingKey
    ] = resultingSortingKey;
    setFilterAndSortingSelection(currFilterAndSortingSelection);
  }
};

const listStyle = {
  root: {
    backgroundColor: '#FAFAFA',
    width: '100%',
  },
};
